import React from 'react';
import {Row, Typography, Col, Icon, Button} from 'antd';

import './index.scss';
import newChannelGif from './new-channel-min.gif'
import newChannelCreated from './channel-created.png'
import summaryGif from './summary-min-caption.gif'
import summaryOnMain from './summary-final.png'

const {Title, Text, Paragraph} = Typography;


function HelpPage() {
  return (
    <div className="__LandingPage__" style={{padding: '5rem', backgroundColor: '#fdfdfd'}}>


      <Row>
        <Typography>
          <Title>Ad hoc channel creation</Title>

          <Paragraph>Often we don't know what topics will be discussed beforehand to create appropriate channels. As
            soon as the team realises that discussion is going in specific direction, an appropriate channel can be
            created. Existing messages can be moved to new channel. Below the team created a new channel for discussing
            the team name.</Paragraph>
          <Row type="flex" justify="center">
            <Col>
              <img alt="Creating new channel" src={newChannelGif}/>
            </Col>

          </Row>
          <Paragraph>Messages that has been already posted can be moved between channels to organize the
            workspace.</Paragraph>

          <Row type="flex" justify="center">
            <Col>
              <img alt="New channel created" src={newChannelCreated}/>
            </Col>

          </Row>
        </Typography>

        <Typography>
          <Title>Summarizing</Title>
          <Paragraph>When discussion reaches a conclusion a summary can be created.</Paragraph>

          <Row type="flex" justify="center">
            <Col>
              <img alt="Summarizing" src={summaryGif}/>
            </Col>

          </Row>
          Summaries that has been accepted by the team will be visible in main channel.
          <Row type="flex" justify="center">
            <Col>
              <img alt="Summary posted in main channel" src={summaryOnMain}/>
            </Col>
          </Row>
        </Typography>
      </Row>


    </div>
  );
}

export default HelpPage;
